import { render, staticRenderFns } from "./PinEditorUI.vue?vue&type=template&id=4cb88f1a&scoped=true&"
import script from "./PinEditorUI.vue?vue&type=script&lang=js&"
export * from "./PinEditorUI.vue?vue&type=script&lang=js&"
import style0 from "./PinEditorUI.vue?vue&type=style&index=0&id=4cb88f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb88f1a",
  null
  
)

export default component.exports